<ng-container *ngIf="model && model.view && layoutMode !== 'gallery'">
  <ng-container *ngIf="viewMode === 'line'">
    <div
      data-cy="people-item"
      #element
      class="people-item"
      tabindex="-1"
      [dragAndDrop]="dragData"
      [ngClass]="{ 'preview-mode': previewState === 'side', 'people-result-line': displayOneCenterLine, clickable: isClickable }"
    >
      <a>
        <ng-container *ngTemplateOutlet="avatar; context: { size: '24px' }"></ng-container>
      </a>
      <div class="main" #main>
        <div
          class="title-container"
          *ngIf="model.view.title?.text"
          [ngClass]="{ 'preview-mode': previewState === 'side', 'with-subtitle': model.view.subtitle }"
        >
          <div class="preview-title" *ngIf="previewState === 'side'">
            <div class="content-title">
              <ng-container *ngTemplateOutlet="title"></ng-container>
              <ng-container *ngTemplateOutlet="favoriteIcon"></ng-container>
            </div>
            <ng-container *ngTemplateOutlet="subtitle"></ng-container>
          </div>
          <div class="base-title" *ngIf="previewState !== 'side'">
            <ng-container *ngTemplateOutlet="title"></ng-container>
            <ng-container *ngTemplateOutlet="subtitle"></ng-container>
            <ng-container *ngTemplateOutlet="favoriteIcon"></ng-container>
          </div>
        </div>
        <ng-container *ngTemplateOutlet="bullets"></ng-container>
      </div>
      <div class="overlay-buttons-container" *ngIf="!displayOneCenterLine">
        <ng-container *featureFlagEnabled="DISABLED_FAVORITES_WORKSPACE_FEATURE_FLAG">
          <div
            class="favorite-star"
            click-invoker
            (click)="toggleFavorite('mouse_click'); $event.stopPropagation()"
            *ngIf="showResultSections?.showFavoriteAction"
          >
            <u-icon
              data-cy="people-item-actions-favorite"
              pTooltip="Remove from favorites"
              tooltipPosition="top"
              tooltipStyleClass="u-tooltip"
              [styles]="{ color: 'var(--purple-500)', fontSize: '14px' }"
              [model]="{ type: 'font', value: 'icon-star-solid' }"
            ></u-icon>
          </div>
        </ng-container>
        <u-icon
          data-cy="people-item-actions-preview"
          *ngIf="isPreviewClickAction(model?.action) && allowPageType && showResultSections.showPreviewIcon"
          class="indicate-preview"
          (click)="onPreviewClick(); $event.stopPropagation()"
          [model]="INDICATE_PREVIEW_ICON"
          pTooltip="Preview"
          tooltipPosition="top"
          tooltipStyleClass="u-tooltip"
        ></u-icon>
        <ng-container *ngTemplateOutlet="squareButton"></ng-container>
        <new-indication *ngIf="showResultSections?.showNewIndication" [tooltip]="showResultSections.showNewIndication"></new-indication>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="viewMode === 'gallery'">
    <div class="gallery-people-container people-view-gallery" [class.selected]="selected">
      <div class="avatar-container">
        <ng-container *ngTemplateOutlet="avatar; context: { withClick: true }"></ng-container>
      </div>
      <div class="main-container">
        <div class="main-container-details">
          <ng-container *ngTemplateOutlet="title"></ng-container>
          <ng-container *ngTemplateOutlet="subtitle"></ng-container>
          <div *ngIf="!model.view.subtitle" class="empty-subtitle"></div>
          <ng-container *ngTemplateOutlet="bullets"></ng-container>
          <div *ngIf="!model.view.bullets?.length" class="empty-bullets"></div>
          <div class="gallery-buttons">
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
          </div>
        </div>
        <div class="square-button-container">
          <ng-container *ngTemplateOutlet="squareButton"></ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-container *ngIf="layoutMode === 'gallery'">
  <gallery-view
    [model]="model"
    [settings]="{
      showFooter: false,
      showThumbnail: false,
      showPreview: allowPageType && showResultSections.showPreviewIcon,
      showCheckbox: showResultSections.isEditable,
      showDrag: showResultSections.isDraggable,
      showFavorite: model.isFavorite && !showResultSections?.showFavoriteAction && showResultSections.showFavoriteIcon !== false,
      showNewIndication: showResultSections?.showNewIndication,
    }"
    (invoke)="galleryInvoke($event)"
    [contextMenuActive]="contextMenuHelper?.source === 'actions'"
    [checked]="checked"
    [selected]="selected"
  >
    <avatar class="people-item-avatar" data-cy="people-item-avatar" [size]="'56px'" [url]="iconModel"></avatar>
    <result-title
      [model]="model.view.title"
      [highlights]="model.highlights"
      (invoke)="
        onInvoke({
          command: $event.command,
          context: makeContext({ appId: model.resource.appId, openWith: model.openWith }, $event.context),
          trigger: $event.trigger,
          source: $event.source,
          immediate: $event.immediate,
        })
      "
    ></result-title>
    <span *ngIf="model?.view?.subtitle?.text">{{ model.view.subtitle.text }}</span>
    <new-indication
      *ngIf="showResultSections?.showNewIndication"
      class="new-indication-gallery"
      [tooltip]="showResultSections.showNewIndication"
    ></new-indication>
    <ng-template let-value pTemplate="dragItem">
      <ng-content select=".drag-ind"></ng-content>
    </ng-template>
  </gallery-view>
</ng-container>

<ng-template #avatar let-size="size" let-withClick="withClick">
  <ng-container *ngIf="withClick; else normalAvatar">
    <avatar [size]="size ? size : '48px'" [url]="iconModel" class="clicked" (click)="onAvatarClick()"></avatar>
  </ng-container>
  <ng-template #normalAvatar>
    <avatar [size]="size ? size : '48px'" [url]="iconModel"></avatar>
  </ng-template>
</ng-template>
<ng-template #title>
  <result-title
    [model]="model.view.title"
    [showSingleLineView]="!model.view.subtitle?.text"
    [highlights]="model.highlights"
    [selected]="selected"
    [dragMetadata]="dragMetadata"
    click-invoker
    (invoke)="
      onInvoke({
        command: $event.command,
        context: makeContext({ appId: model.resource.appId, openWith: model.openWith }, $event.context),
        trigger: $event.trigger,
        source: $event.source,
        immediate: $event.immediate,
      })
    "
    #title
  >
  </result-title>
</ng-template>

<ng-template #subtitle>
  <result-subtitle *ngIf="model.view.subtitle?.text" [model]="model.view.subtitle" [highlights]="model.highlights" click-invoker #subtitle>
  </result-subtitle>
</ng-template>

<ng-template #favoriteIcon>
  <div
    class="favorite"
    click-invoker
    *ngIf="model.isFavorite && !showResultSections?.showFavoriteAction && showResultSections.showFavoriteIcon !== false"
  >
    <u-icon class="icon" [model]="{ type: 'font', value: 'icon-star-solid' }"></u-icon>
  </div>
</ng-template>

<ng-template #semanticIcon>
  <div *ngIf="model?.isAdvanced && showResultSections.showSemantic" class="semantic">
    <u-icon
      pTooltip="This is a semantic search result"
      tooltipPosition="top"
      tooltipStyleClass="u-tooltip"
      [styles]="{ color: '#0083E3', fontSize: '16px' }"
      [model]="{ type: 'font', value: 'icon-lamp1' }"
    ></u-icon>
  </div>
</ng-template>

<ng-template #bullets>
  <div
    class="bullets-container"
    tabindex="-1"
    [ngClass]="{ hidden: previewState === 'side' }"
    *ngIf="!displayOneLine && model.view?.bullets?.length > 0"
  >
    <div data-cy="result-bullet-container" class="bullet-container" *ngFor="let bullet of model.view.bullets">
      <result-bullet
        *ngIf="bullet.parts?.length"
        tabindex="-1"
        [model]="bullet.parts?.length ? bullet : undefined"
        (click)="$event.stopPropagation()"
        click-invoker
        (invoke)="onInvoke({ command: $event, trigger: 'mouse_click' })"
      >
      </result-bullet>
    </div>
  </div>
</ng-template>

<ng-template #squareButton>
  <square-button
    *ngIf="showResultSections?.showContextMenu"
    data-cy="people-item-actions-kebab"
    [active]="contextMenuHelper?.source === 'actions'"
    click-invoker
    (click)="$event.stopPropagation(); openContextMenu($event, 'actions')"
    (auxclick)="$event.stopPropagation(); openContextMenu($event, 'actions')"
    (contextmenu)="$event.stopPropagation(); openContextMenu($event, 'actions')"
    #actions
    >•••</square-button
  >
</ng-template>

<ng-template #buttons>
  <div *ngFor="let link of contactLinks | keyvalue; index as i">
    <u-button
      #linkElement
      pTooltip="Direct {{ link.key }} message"
      tooltipPosition="top"
      tooltipStyleClass="u-tooltip"
      (onClick)="$event.stopPropagation(); peopleService.directMessage(link.value)"
      type="secondary"
      class="icon-button no-border-button action-button"
      [onlyIcon]="true"
      [ngClass]="{ focused: false }"
    >
      <u-icon [model]="link.value.icon" [styles]="{ width: '14px', height: '14px' }"></u-icon>
    </u-button>
  </div>
  <u-button
    data-cy="copy-email-btn"
    #emailElement
    pTooltip="Copy email"
    tooltipPosition="top"
    tooltipStyleClass="u-tooltip"
    (onClick)="$event.stopPropagation(); peopleService.copyEmail(peopleInfo.details)"
    type="secondary"
    class="icon-button no-border-button action-button"
    [onlyIcon]="true"
    [tabindex]="'-1'"
  >
    <u-icon [model]="{ type: 'font', value: 'icon-envelope' }" [styles]="{ fontSize: '14px' }"></u-icon>
  </u-button>
</ng-template>
